<template>
  <div :class="componentClasses">
    <div class="filetype__content"><slot /></div>
  </div>
</template>

<script>
export default {
  name: "FileType",

  props: {
    type: {
      type: String,
      validate: value => ["pdf", "doc"].indexOf(value) !== -1
    },

    inline: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    componentClasses() {
      const arr = ["filetype"];

      if (this.type) {
        arr.push("filetype_" + this.type);
      }

      if (this.inline) {
        arr.push("filetype_inline");
      }

      return arr;
    }
  }
};
</script>

<style lang="scss" scoped>
.filetype {
  display: inline-flex;
  align-items: center;

  &::before {
    content: "";
    display: inline-block;

    width: 18px;
    height: 24px;

    flex-shrink: 0;
  }

  &_pdf {
    &::before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 24' id='spr-pdf' width='100%25' height='100%25'%3E%3Cpath id='spr-pdf_Fill-1' fill='%23FF2929' d='M15.1,24H2.7c-1.5,0-2.8-1.2-2.8-2.7V2.7C-0.1,1.2,1.1,0,2.7,0h8.7l6.6,6.9v14.4 C17.9,22.8,16.7,24,15.1,24'%3E%3C/path%3E%3Cpath id='spr-pdf_Fill-3' fill='%23C41B1B' d='M17.9,6.9H14c-1.5,0-2.7-1.2-2.7-2.6V0L17.9,6.9z'%3E%3C/path%3E%3Cpath id='spr-pdf_Fill-1_1_' fill='%23FFFFFF' d='M12.1,11v3.6h1v-1.3h1.5v-0.8h-1.5v-0.6h1.7V11H12.1z M10.5,12.8c0,0.7-0.3,1-0.9,1H9.1v-2 h0.5C10.2,11.8,10.5,12.1,10.5,12.8L10.5,12.8z M8.2,11v3.6h1.5c1.3,0,1.9-0.8,1.9-1.8c0-1.1-0.6-1.8-1.9-1.8H8.2z M6.7,12.2 c0,0.3-0.3,0.4-0.6,0.4H5.6v-0.8h0.5C6.4,11.8,6.7,11.9,6.7,12.2L6.7,12.2z M4.6,11v3.6h1v-1.1h0.5c0.9,0,1.6-0.3,1.6-1.2 C7.7,11.3,7,11,6.1,11H4.6z M4.1,14.1c0-0.4-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5c0,0.4,0.2,0.5,0.5,0.5 C3.8,14.7,4.1,14.5,4.1,14.1L4.1,14.1z'%3E%3C/path%3E%3C/svg%3E%0A");
    }
  }

  &_doc {
    &::before {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 24' id='spr-doc' width='100%25' height='100%25'%3E%3Cpath id='spr-doc_Fill-1' fill='%233D70CC' d='M15.2,24H2.8C1.2,24,0,22.8,0,21.3V2.7C0,1.2,1.2,0,2.8,0h8.7L18,6.9v14.4 C18,22.8,16.8,24,15.2,24'%3E%3C/path%3E%3Cpath id='spr-doc_Fill-3' fill='%232A5195' d='M18,6.9h-3.9c-1.5,0-2.7-1.2-2.7-2.6V0L18,6.9z'%3E%3C/path%3E%3Cpath id='spr-doc_Fill-1_1_' fill='%23FFFFFF' d='M12.1,12.9c0,1.3,1,1.8,2,1.8c0.4,0,0.7-0.1,1.1-0.2v-0.9c-0.2,0.2-0.6,0.3-0.9,0.3 c-0.6,0-1.1-0.3-1.1-1c0-0.8,0.6-1.1,1.2-1.1c0.3,0,0.7,0.1,0.9,0.3v-0.9C14.8,11,14.4,11,14,11C13,11,12.1,11.5,12.1,12.9 L12.1,12.9z M10.7,12.9c0,0.6-0.3,1-1,1s-1-0.4-1-1c0-0.6,0.3-1,1-1S10.7,12.3,10.7,12.9L10.7,12.9z M7.8,12.9c0,1,0.7,1.9,2,1.9 c1.3,0,2-0.9,2-1.9c0-1-0.7-1.9-2-1.9C8.4,11,7.8,11.8,7.8,12.9L7.8,12.9z M6.4,12.9c0,0.7-0.3,1-0.9,1H5v-2h0.5 C6.1,11.9,6.4,12.2,6.4,12.9L6.4,12.9z M4,11v3.6h1.5c1.3,0,1.9-0.8,1.9-1.8c0-1.1-0.6-1.8-1.9-1.8H4z M3.5,14.2 c0-0.4-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5c0,0.4,0.2,0.5,0.5,0.5C3.2,14.7,3.5,14.6,3.5,14.2L3.5,14.2z'%3E%3C/path%3E%3C/svg%3E%0A");
    }
  }

  &_inline {
    align-items: baseline;
  }

  &__content:not(:empty) {
    margin-left: 5px;
  }
}
</style>
